export const REDIRECT_ROUTE_PAGE_404 = ''

export default {
  REDIRECT_ROUTE_PAGE_404
}



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/constants.js